const chakraColors = [
	{ name: 'Success Color', color: '#2d3748' },
	{ name: 'Success Color Accent', color: '#38a169' },
	{ name: 'Success Color Alt', color: '#3dae71' },
	{ name: 'Success Color Light', color: '#c6f6d5' },

	{ name: 'Info Color', color: '#014361' },
	{ name: 'Info Color Accent', color: '#3182ce' },
	{ name: 'Info Color Alt', color: '#2d75b8' },
	{ name: 'Info Color Bold', color: '#2d76bb' },
	{ name: 'Info Color Light', color: '#bee3f8' },

	{ name: 'Warning Color', color: '#2d3748' },
	{ name: 'Warning Color Accent', color: '#dd6b20' },
	{ name: 'Warning Color Alt', color: '#b35719' },
	{ name: 'Warning Color Light', color: '#feebc8' },

	{ name: 'Error Color Accent', color: '#a92525' },
	{ name: 'Error Color Alt', color: '#d32f2f' },
	{ name: 'Error Color Bold', color: '#ef5350' },
	{ name: 'Error Color Light', color: '#fed7d7' },
];

const themeColors = alertsDlxBlock.colorPalette;
chakraColors.push( ...themeColors );
export default chakraColors;
